import { lazy } from "react";

const CustomAltasExamenesStatics = lazy(
  () => import("./AltasExamenesStatistics"),
);

export default CustomAltasExamenesStatics;
